import { isLocalOrDevEnv } from '@deepcloud/deep-ui-utils'
import { useDeepBoxBoxInfoStore } from '@/stores/deepbox/box-info.ts'
import { useBox } from '../box/box'
import type { Node } from '@deepcloud/api-deep-box'

export function useNodePayment(nodeRef: MaybeRefOrGetter<Node | null>) {
  const node = toValue(nodeRef)

  const deepBoxBoxInfoStore = useDeepBoxBoxInfoStore()

  const { isBoxTypeAbaImmo } = useBox(
    computed(() => deepBoxBoxInfoStore.boxInfo),
  )

  const isPaymentStatusTransmitted = computed(
    () =>
      node?.tags &&
      node.tags.findIndex((t) => t.key === 'payment-status-transmitted') > -1,
  )

  const canNodePayment = computed(
    () =>
      isLocalOrDevEnv(import.meta.env) &&
      isBoxTypeAbaImmo.value &&
      !!node?.documentType &&
      ['invoice', 'invoice-i', 'reminder'].includes(node!.documentType) &&
      !isPaymentStatusTransmitted.value,
  )

  return {
    canNodePayment,
  }
}
